// if(!('customElements' in window)){
//     const defined:{[k: string]: CustomElementConstructor} = {},
//         whenDefine: {[k: string]: Function[]} = {};
//     //@ts-ignore
//     window['customElements'] = {
//         define(name: string, constructor: CustomElementConstructor, options?: ElementDefinitionOptions) {
//             if(defined[name]) throw `Element with name ${name} already defined`;
//             defined[name] = constructor;
//             // @ts-ignore
//             document['registerElement'](name, { prototype: constructor.prototype });
//             whenDefine[name]?.forEach(c=>c(constructor));
//         },
//         get(name: string): CustomElementConstructor | undefined {
//             return defined[name];
//         },
//         upgrade(root: Node) {
//             //
//         },
//         whenDefined(name: string): Promise<CustomElementConstructor> {
//             if(defined[name]) return Promise.resolve(defined[name]);
//             return new Promise<CustomElementConstructor>(r=>{
//                 if(whenDefine[name])whenDefine[name].push(r);
//                 else whenDefine[name] = [r];
//             });
//         }
//     }
// }
import "./scroller/index.js";
import "./time/local-time.js";
import "./time/time-counter.js";
import "./textarea/index.js"
import "./select-element/CustomSelectElement.js"